import { Phone } from "lucide-react";
import { RESTAURANT_INFO } from "../data/menu";

const WhatsAppIcon = ({ size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M20.52 3.48A11.85 11.85 0 0 0 12.04 0C5.5 0 .2 5.3.2 11.84c0 2.08.55 4.12 1.6 5.92L0 24l6.4-1.68a11.83 11.83 0 0 0 5.64 1.44h.01c6.54 0 11.84-5.3 11.84-11.84 0-3.16-1.23-6.13-3.37-8.44Zm-8.48 18.2h-.01a9.8 9.8 0 0 1-5-1.37l-.36-.21-3.8 1 1.02-3.7-.23-.38a9.83 9.83 0 0 1-1.5-5.18c0-5.43 4.42-9.85 9.86-9.85a9.78 9.78 0 0 1 6.97 2.88 9.78 9.78 0 0 1 2.89 6.97c0 5.43-4.43 9.84-9.84 9.84Zm5.4-7.36c-.3-.15-1.75-.86-2.02-.96-.27-.1-.46-.15-.66.15-.2.3-.76.96-.94 1.16-.17.2-.34.22-.64.07-.3-.15-1.26-.46-2.4-1.47-.88-.78-1.48-1.75-1.65-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.34.44-.5.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.9-2.18-.24-.57-.48-.5-.66-.5l-.56-.01a1.07 1.07 0 0 0-.78.37c-.27.3-1.02 1-1.02 2.44 0 1.44 1.05 2.83 1.2 3.03.15.2 2.07 3.17 5.02 4.45.7.3 1.25.48 1.68.62.7.22 1.34.19 1.85.12.56-.08 1.75-.71 2-1.4.25-.7.25-1.28.17-1.4-.07-.13-.27-.2-.57-.35Z" />
  </svg>
);

export const FloatingActions = () => {
  return (
    <div
      data-testid="floating-actions"
      className="fixed bottom-4 right-3 sm:bottom-8 sm:right-6 z-40 flex flex-col gap-2.5 sm:gap-3 items-end"
    >
      <a
        href={`https://wa.me/${RESTAURANT_INFO.whatsapp}?text=${encodeURIComponent(
          "Hola, quiero hacer un pedido en Mariscos Popeye 1985.",
        )}`}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Pedir por WhatsApp"
        className="group flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white p-3 sm:p-4 rounded-full shadow-[0_10px_30px_-5px_rgba(37,211,102,0.5)] transition-all hover:scale-105"
      >
        <WhatsAppIcon size={22} />
        <span className="hidden sm:inline-block text-xs uppercase tracking-widest font-semibold pr-1">
          Pedir
        </span>
      </a>
      <a
        href={`tel:+52${RESTAURANT_INFO.phone}`}
        data-testid="floating-call-button"
        aria-label="Llamar al restaurante"
        className="flex items-center justify-center bg-red-600 hover:bg-red-700 text-white p-3 sm:p-4 rounded-full shadow-[0_10px_30px_-5px_rgba(220,38,38,0.5)] transition-all hover:scale-105"
      >
        <Phone size={22} strokeWidth={2.5} />
      </a>
    </div>
  );
};
